import { useSelector, useDispatch } from 'react-redux';
import lobbiesSlice from './lobbiesSlice';

function useLobbies() {
    const { lobbies } = useSelector((state) => {
        return state.lobbies;
    });
    const dispatch = useDispatch();
  
    function setLobbies(lobbies) {
      dispatch(lobbiesSlice.actions.setLobbies(lobbies));
    }
  
    return { lobbies, setLobbies };
}

export default useLobbies;